import axios from 'axios';
import { BACKEND_URL } from '../../../utils/index.js';

export const addFeedback = async (email, feedback) => {
    return axios.post(`${BACKEND_URL}/feedbacks/${email}`, feedback);
};

export const addFeedbackFiles = async (trainingSessionId, files, setLoaded) => {
    return axios.put(`${BACKEND_URL}/feedbacks/files/${trainingSessionId}`, files, {
        onUploadProgress: progressEvent => {
            setLoaded(progressEvent.loaded / progressEvent.total * 100)
        }
    });
};

export const deleteFeedbackFile = async (trainingSessionId, fileName) => {
    return axios.delete(`${BACKEND_URL}/feedbacks/files/${trainingSessionId}/${encodeURIComponent(fileName)}`);
};

export const getAllFeedbacksOfWeekOfAthlete = async (email, year, calendarWeek) => {
    return axios.get(`${BACKEND_URL}/feedbacks/${email}/${year}/${calendarWeek}`);
};

export const getFeedbackFiles = async (trainingSessionId, setLoaded) => {
    return axios.get(`${BACKEND_URL}/feedbacks/files/${trainingSessionId}`, {
        onDownloadProgress: progressEvent => {
            setLoaded(progressEvent.loaded / progressEvent.total * 100)
        }
    });
};

export const getFeedbackOfAthlete = async (email, year, calendarWeek, dayOfWeek) => {
    return axios.get(`${BACKEND_URL}/feedbacks/${email}/${year}/${calendarWeek}/${dayOfWeek}`);
};

export const updateFeedback = async (email, feedback) => {
    return axios.put(`${BACKEND_URL}/feedbacks/${email}`, feedback);
};

export const updateFeedbackFiles = async (trainingSessionId, files, setLoaded) => {
    return axios.put(`${BACKEND_URL}/feedbacks/files/${trainingSessionId}`, files, {
        onUploadProgress: progressEvent => {
            setLoaded(progressEvent.loaded / progressEvent.total * 100)
        }
    });
};

export const updateHasExtendedFeedback = async (email, hasExtendedFeedback) => {
    return axios.put(`${BACKEND_URL}/athletes/${email}/hasExtendedFeedback`, hasExtendedFeedback);
};

export const getFeedbackNotificationsForCoach = async (email, limit = 50) => {
    return axios.get(`${BACKEND_URL}/feedbackNotifications/${email}`, {
        params: { limit }
    });
};

export const dismissFeedbackNotificationsForCoach = async (email) => {
    return axios.post(`${BACKEND_URL}/feedbackNotifications/${email}/dismiss`, {});
};

export const dismissOneFeedbackNotificationForCoach = async (email, feedbackId) => {
    return axios.post(`${BACKEND_URL}/feedbackNotifications/${email}/dismissOne`, { feedbackId });
};